// extracted by mini-css-extract-plugin
module.exports = {"svg":"Icon_svg__2YJrO","xs":"Icon_xs__2GnUn","small":"Icon_small__pexh1","full":"Icon_full__1H-Um"};